const cloudfrontLoader = ({ src, width, quality = 75 }) => {
  return `${src}?w=${width}&q=${quality}`;
};

export default cloudfrontLoader;
